function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("path", {
    style: {
      fill: "#FCAC2B"
    },
    d: "M461.558,433.582l-0.703-7.996c-5.108-57.609-53.238-101.865-111.07-102.131 c-0.651,0-1.294,0.069-1.954,0.077c-25.222-22.642-58.072-34.915-91.958-34.358c-33.484,0-65.81,12.272-90.844,34.512 c-1.157-0.043-2.297-0.231-3.428-0.231C103.65,323.789,55.503,368.234,50.549,425.98l-0.36,9.641l8.57,0.317v7.499h394.228v-9.102 L461.558,433.582z"
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#FA962A"
    },
    d: "M460.821,425.586c-5.108-57.6-53.212-101.848-111.035-102.131c-0.651,0-1.294,0.069-1.954,0.077 c-25.222-22.642-58.072-34.915-91.958-34.358c-33.484,0-65.81,12.272-90.844,34.512c-1.157-0.043-2.297-0.231-3.428-0.231 C103.65,323.789,55.503,368.234,50.549,425.98l-0.36,9.641l17.14,0.634l0.326-9.247c4.319-48.73,45.019-86.173,93.946-86.413 c10.344,0.06,20.603,1.834,30.364,5.245c-5.142,4.114-9.873,8.699-14.141,13.712c-41.437-9.11-82.411,17.089-91.521,58.526 c-0.557,2.545-0.994,5.125-1.286,7.713l-0.531,8.57l17.14,1.063l0.48-8.03c4.105-32.875,34.092-56.195,66.967-52.09 c27.236,3.402,48.687,24.854,52.09,52.09l0.506-0.069l0.506,8.099l17.14-1.063l-0.583-8.065c-0.129-9.47,7.43-17.252,16.9-17.38 c9.47-0.129,17.252,7.43,17.38,16.9l-0.994,7.987l17.003,2.125l1.071-8.57c0.043-0.351,0.069-0.711,0.06-1.063 c0-18.932-15.349-34.281-34.281-34.281c-9.196-0.009-18.006,3.728-24.399,10.336c-2.468-5.322-5.536-10.353-9.144-14.981 c9.299-8.09,21.22-12.53,33.544-12.495c28.384,0.026,51.395,23.037,51.421,51.421h0.728l-0.189,6.728l17.14,0.471l0.163-5.931 c4.011-13.618,18.306-21.408,31.933-17.397c8.587,2.528,15.238,9.35,17.56,17.997l1.44,6.428l16.729-3.737l-1.5-6.693 c-5.828-22.857-29.087-36.655-51.935-30.827c-7.053,1.8-13.532,5.373-18.82,10.387c-1.937-5.596-4.585-10.91-7.893-15.821 c25.873-20.577,63.522-16.283,84.099,9.581c6.805,8.562,11.141,18.82,12.53,29.67l0.857,8.57l17.14-1.714l-0.908-8.759 c-3.728-29.199-23.748-53.744-51.601-63.265c-2.957-7.113-6.676-13.901-11.073-20.226c43.151,6.608,76.215,41.831,80.088,85.316 l0.711,8.03l17.063-1.526L460.821,425.586z M255.874,357.735c-16.832-0.034-33.072,6.179-45.585,17.44 c-4.551-3.745-9.504-6.95-14.784-9.573c33.244-33.304,87.184-33.355,120.488-0.111c0.034,0.034,0.077,0.077,0.111,0.111 c-5.279,2.571-10.25,5.733-14.818,9.427C288.792,363.88,272.62,357.727,255.874,357.735z M349.786,357.735 c-5.374,0.009-10.738,0.583-15.992,1.714c-30.656-36.038-82.042-46.322-124.199-24.854c-6.625-3.222-13.558-5.785-20.688-7.636 c19.754-13.421,43.082-20.611,66.967-20.646c42.517,0,79.454,19.909,97.752,51.601C352.348,357.847,351.08,357.735,349.786,357.735 z"
  }), React.createElement("path", {
    style: {
      fill: "#FA962A"
    },
    d: "M161.602,392.016c-19.643,0.009-36.766,13.37-41.565,32.412l-2.143,9.641l16.729,3.737l2.083-9.376 c3.522-13.755,17.526-22.051,31.281-18.529c9.204,2.357,16.352,9.59,18.606,18.82l2.691,9.11l16.429-4.859l-2.571-8.81 C198.256,405.223,181.167,391.99,161.602,392.016z"
  })), React.createElement("path", {
    style: {
      fill: "#E5E5E5"
    },
    d: "M7.338,426.297h497.071l0,0l0,0c0,47.333-38.369,85.702-85.702,85.702H93.04 C45.707,511.999,7.338,473.63,7.338,426.297L7.338,426.297L7.338,426.297z"
  }), React.createElement("path", {
    style: {
      fill: "#DEDEDE"
    },
    d: "M367.826,426.297c-46.279,43.074-107.127,69.496-164.368,85.702h215.249 c47.333,0,85.702-38.369,85.702-85.702H367.826z"
  }), React.createElement("path", {
    style: {
      fill: "#FA962A"
    },
    d: "M118.117,314.619c-9.761-20.431-8.879-44.351,2.348-64.011c9.076-15.966,9.076-35.523,0-51.49 c-12.067-21.237-12.067-47.256,0-68.493c3.094-7.542,5.451-15.358,7.045-23.345l16.729,3.771 c-1.945,9.667-4.919,19.103-8.879,28.144c-9.067,15.966-9.067,35.515,0,51.481c12.084,21.228,12.084,47.265,0,68.493 c-8.433,14.775-9.102,32.738-1.774,48.096L118.117,314.619z"
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#E5E5E5"
    },
    d: "M466.426,33.183l-253.403,7.456l-15.666-15.666c-6.428-6.428-15.152-10.044-24.245-10.044H93.64 c-4.465,7.885-7.105,16.669-7.713,25.711h67.105v17.14H87.178c1.268,6.008,3.445,11.793,6.462,17.14h59.391v17.14h-52.895 c1.825,8.476,1.825,17.235,0,25.711h72.992c9.093,0,17.817-3.617,24.245-10.044l15.649-15.666l252.323,14.844 c20.337,1.328,37.906-14.072,39.234-34.409s-14.072-37.906-34.409-39.234c-1.243-0.086-2.494-0.103-3.745-0.051V33.183z"
  }), React.createElement("rect", {
    x: 33.049,
    y: 40.639,
    style: {
      fill: "#E5E5E5"
    },
    width: 17.14,
    height: 17.14
  }), React.createElement("rect", {
    x: 33.049,
    y: 74.919,
    style: {
      fill: "#E5E5E5"
    },
    width: 25.711,
    height: 17.14
  }), React.createElement("rect", {
    x: 33.049,
    y: 109.2,
    style: {
      fill: "#E5E5E5"
    },
    width: 34.281,
    height: 17.14
  }), React.createElement("rect", {
    x: 33.049,
    y: 6.358,
    style: {
      fill: "#E5E5E5"
    },
    width: 25.111,
    height: 17.14
  })), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#FCAC2B"
    },
    d: "M57.123,336.533c-0.771-2.134-1.406-4.114-2.031-6.042c-1.183-4.028-2.708-7.953-4.568-11.715 c-11.955-21.211-11.844-47.153,0.274-68.27c9.17-15.898,9.144-35.489-0.086-51.353c-12.075-21.237-12.075-47.256,0-68.493 c9.23-15.872,9.256-35.472,0.069-51.37c-12.153-21.263-12.178-47.359-0.06-68.647l3.24-6.085c2.22-4.182,7.405-5.776,11.587-3.557 l0,0l0,0c4.182,2.22,5.768,7.405,3.548,11.587l-3.368,6.359c-9.162,16.001-9.204,35.643-0.111,51.687 c12.067,21.237,12.067,47.256,0,68.493c-9.196,15.932-9.196,35.558,0,51.49c12.067,21.237,12.067,47.256,0,68.493 c-9.076,15.966-9.076,35.523,0,51.49c2.357,4.679,4.302,9.556,5.811,14.569c0.566,1.714,1.14,3.557,1.843,5.502L57.123,336.533z"
  }), React.createElement("path", {
    style: {
      fill: "#FCAC2B"
    },
    d: "M89.295,325.512c-0.883-2.185-1.92-4.319-3.085-6.368c-12.075-21.237-12.075-47.265,0-68.501 c9.196-15.932,9.196-35.558,0-51.49c-12.075-21.237-12.075-47.256,0-68.493c9.076-15.966,9.076-35.523,0-51.49 c-11.595-21.331-11.801-47.05-0.54-68.561l1.868-3.522c2.22-4.182,7.405-5.768,11.587-3.548l0,0 c4.182,2.22,5.768,7.405,3.548,11.587l-2.057,3.857c-8.407,16.352-8.185,35.806,0.608,51.961 c11.973,21.185,11.921,47.11-0.137,68.253c-9.196,15.932-9.196,35.558,0,51.49c12.084,21.237,12.084,47.256,0,68.493 c-9.067,15.966-9.067,35.523,0,51.49c1.568,2.725,2.94,5.553,4.105,8.467L89.295,325.512z"
  })), React.createElement("path", {
    style: {
      fill: "#DEDEDE"
    },
    d: "M465.346,106.903c20.311,1.303,37.829-14.107,39.14-34.418c1.183-18.443-11.475-34.915-29.61-38.506 C420.85,60.419,364.458,81.707,306.438,97.553L465.346,106.903z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.18a2638b.svg";
export { ForwardRef as ReactComponent };